import React, { Fragment } from "react";

import { lazyWithRetry } from "../../core/lazy_with_retry";
import { OfferingDetailsDayPassWithCapacity } from "../template_offering_details_daypass_with_capacity";
import { useVillageWorkspacesAnalytics } from "./village-workspaces_analytics";
import {
  partnerConfig,
  testimonials,
} from "./village-workspaces_partner_config";
import { ImageData } from "../../data";

const Theme = lazyWithRetry(() => import("./village-workspaces_theme"));
const imagesDesktop: ImageData[] = [
  {
    url: "https://meet-production.s3.amazonaws.com/images/space_image/image/169c4a4b-ed46-4c81-9272-b0c7f6b20cf6/medium_Reception.jpeg",
    width: 5328,
    height: 2997,
  },
  {
    url: "https://meet-production.s3.amazonaws.com/images/space_image/image/4072c280-8dce-4421-b5a1-c226cb82b1af/medium_Private_Office.jpg",
    width: 1200,
    height: 800,
  },
  {
    url: "https://meet-production.s3.amazonaws.com/images/space_image/image/967a38cf-c58f-48ad-83f3-01687bff2356/medium_Private_Office_2.jpg",
    width: 1200,
    height: 800,
  },
];
const imagesMobile: ImageData[] = imagesDesktop;

export function OfferingVillageWorkspacesDayOffice() {
  useVillageWorkspacesAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPassWithCapacity
        showAddress
        showDirections
        getDesktopImagesBasedOnLocation={() => {
          return imagesDesktop;
        }}
        getMobileImagesBasedOnLocation={() => {
          return imagesMobile;
        }}
        partnerConfig={partnerConfig}
        data={{
          testimonials: testimonials,
        }}
      />
    </Fragment>
  );
}
